import { useNavigate } from 'react-router-dom';

import { useRetailer } from '@lib/core/retailers/hooks/useRetailer';
import { useApp } from '@lib/core/service/hooks';
import { setServiceLocale } from '@lib/core/service/slices';
import { prependBasename } from '@lib/core/service/utils';
import { useTypedDispatch } from '@lib/tools/views/hooks/useTypedDispatch';
import { PAGES } from '@lib/tools/views/urls';

import { Disclaimer } from '@components/pmi/src/templates/DisclaimerDTE/Disclaimer';

export const DisclaimerContainer = () => {
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();

  const { locale } = useApp();
  const { retailerLanguages } = useRetailer();

  const handleOnAgree = () => {
    navigate(prependBasename(PAGES.ta.landingRemote));
  };

  const onLanguageSelect = code => {
    dispatch(setServiceLocale(code));
  };

  return (
    <Disclaimer
      selectedLanguageCode={locale}
      supportedLanguages={retailerLanguages}
      onAgree={handleOnAgree}
      onLanguageSelect={onLanguageSelect}
    />
  );
};
